import { NavShell } from "./NavShell";

function App() {
  return <NavShell />;
}

export default App;
